import React, {useEffect, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {IState} from '../../store/reducers';
import {loadWorkflows} from '../../store/actions/workflowActions';
import {setShowSubscriptionDialog} from '../../store/actions/uiActions';
import SubscriptionDialog from './SubscriptionDialog';
import {loadUsers} from '../../store/actions/userActions';
import {isLoggedIn} from '../../utils/auth';
import {useCurrentUser, useSubscription} from "../../hooks/use-user-current-workspace";
import {loadWorkspaces} from '../../store/actions/workspaceActions';

interface SubscriptionManagerProps {
}

const SubscriptionManagerContainer = ({}: SubscriptionManagerProps) => {
  /*
   * Handle subscription Dialog in a common place;
   * Also handle some subscription logic.
   */
  const showSubscriptionDialog = useSelector((state: IState) => state.ui.showSubscriptionDialog);
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();
  const subscription = useSubscription();

  useEffect(() => {
    /*
     * Load all workflows and users in order to keep track of a user's usage.
     *
     * - a User can create as many workflows as it wants to,
     * but it is limited to a certain amount of `active` workflows
     * based on its subscription.
     * - users created after limit has been reached are only allowed
     * to be created as `Guest` users.
     */
    if (!isLoggedIn(currentUser)) {
      return;
    }

    dispatch(loadWorkflows());
    dispatch(loadUsers({
      page: 0,
      page_size: -1,
      reload: true
    }));
  }, []);

  const onSubscriptionDialogClose = () => {
    dispatch(setShowSubscriptionDialog(false));
  }

  return <SubscriptionDialog
    show={showSubscriptionDialog}
    onClose={onSubscriptionDialogClose}
    subscription={subscription}
  />
};

export default SubscriptionManagerContainer;
